module.exports = __webpack_public_path__ + "img/record_table.9e10d010.png";